import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import UsePagination from '../../../../components/pagination'
import { Button, Loader } from '../../../../components/UI'

import {
  selectLinkedDevicesPagination,
  selectLoadingGetLinkedDevices,
  selectLoadingLogoutFromAllDevices,
} from '../../../../routing/fetchingfunction/user/user.reducer'
import {
  getLinkedDevices,
  logout,
  logoutFromAllDevices,
} from '../../../../routing/fetchingfunction/user/user.action'

import { getPaginationTotalLength } from '../../../../helpers'

const LinkedDevices = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { linkedDevices, linkedDevicesPage, linkedDevicesPageSize, linkedDevicesTotal } =
    useSelector(selectLinkedDevicesPagination)
  const isLoading = useSelector(selectLoadingGetLinkedDevices)
  const isLogoutLoading = useSelector(selectLoadingLogoutFromAllDevices)

  const handleLogoutFromAllDevices = () => {
    navigate('/')
    dispatch(logoutFromAllDevices())
    dispatch(logout())
  }

  const handlePageChange = (_, value) => {
    if (linkedDevicesPage !== value) {
      dispatch(
        getLinkedDevices({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    dispatch(
      getLinkedDevices({
        page: linkedDevicesPage || 1,
      })
    )
  }, [])

  const linkedDevicesContent = linkedDevices.map((linkedDevice) => {
    return (
      <li
        key={`device-${linkedDevice.logged_in_time}`}
        className="flex flex-col w-full rounded-[8px] border-[#FFCA84] border-[1px] py-[10px] px-[14px]"
      >
        <span className="mb-[4px] text-sm font-semibold text-primary-100">
          {linkedDevice.os} {linkedDevice.device}
        </span>

        <span className="text-sm font-normal text-primary-100">
          Last active at {moment(linkedDevice.logged_in_time).format('LLL')}
        </span>
      </li>
    )
  })

  return (
    <div className="mt-[24px] border-[1px] border-solid border-[#FFCA84] rounded-[10px] p-[20px]">
      <h4 className="text-sm font-semibold text-primary-100">Linked Devices</h4>

      <h5 className="my-[10px] font-normal text-primary-100 text-sm">
        You have logged into your Apolo P2P account from the following devices:
      </h5>

      {linkedDevices.length ? (
        <ul className="flex flex-col gap-y-[10px]">{linkedDevicesContent}</ul>
      ) : (
        isLoading && (
          <div className="flex items-center justify-center w-full">
            <Loader className="text-primary-100" />
          </div>
        )
      )}

      <Button
        type="button"
        variant="secondary"
        className="min-w-[200px] mt-[10px] !bg-white text-sm hover:!bg-primary-button-hover hover:!border-primary-button-hover hover:!text-white"
        isLoading={isLogoutLoading}
        onClick={handleLogoutFromAllDevices}
      >
        Logout From All Devices
      </Button>

      {linkedDevicesTotal > linkedDevicesPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(linkedDevicesTotal, linkedDevicesPageSize)}
            page={linkedDevicesPage}
            onChange={handlePageChange}
            loading={isLoading}
            altColors
          />
        </div>
      )}
    </div>
  )
}

export default LinkedDevices
